<template>
  <v-menu
    v-model="is_active"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="380px"
    min-width="380px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        outlined
        hide-details
        background-color="#F1F2F6"
        :label="label"
        prepend-inner-icon="mdi-account"
        readonly
        :value="value"
        v-on="on"
      ></v-text-field>
    </template>
    <v-card>
      <v-list>
        <template v-for="(picker, index) in pickers">
          <v-divider :key="index * 10" v-if="index > 0"></v-divider>
          <occupants-counter
            :value="picker.value"
            :label="picker.label"
            :id="picker.id"
            :note="picker.note"
            @setValue="setValue"
            :key="index"
          />
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import OccupantsCounter from "./OccupantsCounter.vue";
export default {
  components: {
    "occupants-counter": OccupantsCounter,
  },
  props: ["pickers", "label", "value"],
  data() {
    return {
      is_active: false,
    };
  },
  methods: {
    setValue(id, value) {
      this.$emit("changeValue", id, value);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>